import React from 'react'
import IfoImg from "../../../../Assets/Images/cashbox_9.1.png"
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import RestaurantIcon from '@mui/icons-material/Restaurant';
function Perehod() {
  return (
    <div className='flex flex-col items-center lg:items-start lg:flex-row lg:ml-8 justify-center space-y-10 lg:space-x-20'>
      <div className='-max-w-[685px]'>
        <ul data-aos="zoom-in-up" className='flex flex-col space-y-8'>
          <div className='flex flex-col items-center md:items-start space-y-10 md:space-y-0 md:flex-row justify-between md:space-x-10'>
            <li className='text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <LocalGroceryStoreIcon style={{ "inlineSize": "40px", " blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>МАГАЗИНЫ</strong>
                <p className='mt-1 text-[13px] sm:text-[18px]'>Продукты, бытовая техника, товары для дома и т.д.</p>
              </div>
            </li>
            <li className=' text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <MedicalInformationIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>УСЛУГИ</strong>
                <p className=' text-[13px] sm:text-[18px]'>Продукты, бытовая техника, товары для дома и т.д.</p>
              </div>

            </li>
          </div>
          <div className='flex flex-col items-center md:items-start space-y-10 md:space-y-0 md:flex-row justify-between md:space-x-10'>
            <li className='text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <DirectionsCarFilledIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>ПЕРЕВОЗКИ И КУРЬЕРЫ</strong>
                <p className='mt-1 text-[13px] sm:text-[18px]'>Продукты, бытовая техника, товары для дома и т.д.</p>
              </div>
            </li>
            <li className=' text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <RestaurantIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>РЕСТОРАНЫ</strong>
                <p className=' text-[13px] sm:text-[18px]'>Продукты, бытовая техника, товары для дома и т.д.</p>
              </div>

            </li>
          </div>
        </ul>
        <div data-aos="zoom-in-up"
          data-aos-anchor-placement="center-bottom" className='text-white text-center md:text-left mt-10'>
          <strong className='text-[22px] sm:text-[30px]'>АПТЕКИ</strong>
          <p className='text-[14px] sm:text-[18px]'>Продукты, бытовая техника, товары для дома и т.д. .</p>
        </div>
      </div>
      <img data-aos="zoom-in-up" alt='Logo' className='mx-auto lg:mx-0' src={IfoImg} width={227} height={543} />
    </div>
  )
}

export default Perehod